export default async function (type?: string, query?: string) {
  const router = useRouter()
  const { path } = useRoute()
  const queryPath = type ? { [type]: query } : {}
  await router.push({
    path,
    query: queryPath
  })
}
